/* Y Beauty — storefront behaviour. No dependencies. */
(function () {
  'use strict';

  var routes = window.theme && window.theme.routes ? window.theme.routes : {
    root: '/', cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change', cart_update: '/cart/update', predictive_search: '/search/suggest'
  };
  var strings = (window.theme && window.theme.strings) || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function root(path) { return (routes.root || '/').replace(/\/$/, '') + path; }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  }
  window.themeToast = toast;

  /* ---------- overlay + drawers ---------- */
  var overlay = document.createElement('div');
  overlay.className = 'drawer-overlay';
  document.body.appendChild(overlay);
  var openDrawer = null;
  function showDrawer(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) hideDrawer();
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    overlay.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    openDrawer = el;
    var f = el.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function hideDrawer() {
    if (!openDrawer) return;
    openDrawer.classList.remove('open');
    openDrawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('open');
    document.documentElement.style.overflow = '';
    openDrawer = null;
  }
  overlay.addEventListener('click', hideDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideDrawer(); });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) { e.preventDefault(); showDrawer(target); }
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); hideDrawer(); }
  });

  /* ---------- countdowns ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickCountdowns() {
    var now = Date.now();
    $$('[data-countdown]').forEach(function (el) {
      var end;
      var iso = el.getAttribute('data-end');
      if (iso) {
        end = Date.parse(iso);
      }
      if (!end || isNaN(end) || end < now) {
        // daily reset at midnight in the configured UTC offset (hours)
        var off = parseFloat(el.getAttribute('data-offset') || '9');
        var shifted = new Date(now + off * 3600000);
        shifted.setUTCHours(24, 0, 0, 0);
        end = shifted.getTime() - off * 3600000;
      }
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var hh = $('[data-h]', el), mm = $('[data-m]', el), ss = $('[data-s]', el);
      if (hh) hh.textContent = pad(h);
      if (mm) mm.textContent = pad(m);
      if (ss) ss.textContent = pad(sec);
      $$('[data-countdown-text]').forEach(function (t) { t.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec); });
    });
  }
  if ($('[data-countdown]')) { tickCountdowns(); setInterval(tickCountdowns, 1000); }

  /* ---------- hero carousel ---------- */
  function initCarousel(el) {
    if (el._init) return; el._init = true;
    var slides = $$('.slide', el), dots = $$('.dots button', el), i = 0, timer;
    if (slides.length < 2) return;
    var delay = parseInt(el.getAttribute('data-autoplay') || '0', 10) * 1000;
    function go(n) {
      slides[i].classList.remove('on'); if (dots[i]) { dots[i].classList.remove('on'); dots[i].setAttribute('aria-current', 'false'); }
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('on'); if (dots[i]) { dots[i].classList.add('on'); dots[i].setAttribute('aria-current', 'true'); }
    }
    function play() { if (delay) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, delay); } }
    var l = $('.arw.l', el), r = $('.arw.r', el);
    if (l) l.addEventListener('click', function () { go(i - 1); play(); });
    if (r) r.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', play);
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); x0 = null; play(); });
    play();
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- copy coupon codes ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy]');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-copy');
    var done = function () {
      btn.classList.add('copied');
      toast((strings.copied || 'Copied') + ': ' + code);
      setTimeout(function () { btn.classList.remove('copied'); }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else { var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (err) {} ta.remove(); done(); }
  });

  /* ---------- predictive search ---------- */
  $$('[data-predictive-search]').forEach(function (form) {
    var input = $('input[name="q"]', form), results = $('.predictive', form), trend = $('.trend', form);
    if (!input || !results) return;
    var ctrl;
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; if (trend) trend.classList.add('idle'); return; }
      if (trend) trend.classList.remove('idle');
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = routes.predictive_search + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,query,page,article&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html), inner = doc.querySelector('#predictive-search-results');
          results.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(function () {});
    }, 220);
    input.addEventListener('input', run);
    input.addEventListener('focus', run);
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) { results.innerHTML = ''; if (trend) trend.classList.add('idle'); } });
    form.addEventListener('keydown', function (e) { if (e.key === 'Escape') { results.innerHTML = ''; input.blur(); } });
  });

  /* ---------- cart ---------- */
  function cartSections() {
    var ids = ['cart-drawer'];
    $$('[data-cart-section]').forEach(function (el) { var id = el.getAttribute('data-cart-section'); if (ids.indexOf(id) < 0) ids.push(id); });
    return ids;
  }
  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = parseHTML(html);
      if (id === 'cart-drawer') {
        var fresh = doc.querySelector('[data-cart-drawer-inner]'), cur = $('[data-cart-drawer-inner]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var countEl = doc.querySelector('[data-cart-count-value]');
        if (countEl) setCartCount(countEl.getAttribute('data-cart-count-value'));
      } else {
        var target = document.getElementById('shopify-section-' + id);
        var src = doc.getElementById('shopify-section-' + id);
        if (target && src) target.innerHTML = src.innerHTML;
      }
    });
  }
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  function cartError(msg) { toast(msg || strings.cart_error || 'Something went wrong'); }

  function addToCart(formData, button) {
    if (button) { button.classList.add('loading'); button.setAttribute('aria-busy', 'true'); }
    formData.append('sections', cartSections().join(','));
    formData.append('sections_url', window.location.pathname);
    return fetch(routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { cartError(data.description || data.message); return; }
        renderCartSections(data.sections);
        if (window.theme.cartType === 'drawer' && $('#CartDrawer')) showDrawer($('#CartDrawer'));
        else if (window.theme.cartType === 'page') window.location.href = routes.cart;
        else toast(strings.added || 'Added to cart');
      })
      .catch(function () { cartError(); })
      .finally(function () { if (button) { button.classList.remove('loading'); button.removeAttribute('aria-busy'); } });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    if (window.theme.cartType === 'page') return;
    e.preventDefault();
    addToCart(new FormData(form), form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    var fd = new FormData();
    fd.append('id', quick.getAttribute('data-quick-add'));
    fd.append('quantity', '1');
    addToCart(fd, quick);
  });

  var changing = false;
  function changeLine(line, qty, row) {
    if (changing) return; changing = true;
    if (row) row.style.opacity = '.5';
    fetch(routes.cart_change + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: cartSections(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { cartError(data.description || data.message); if (row) row.style.opacity = ''; return; }
        renderCartSections(data.sections);
      })
      .catch(function () { cartError(); if (row) row.style.opacity = ''; })
      .finally(function () { changing = false; });
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-line-remove'), 10), 0, rm.closest('.citem')); return; }
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty'), input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.min || '0', 10), max = input.max ? parseInt(input.max, 10) : Infinity;
    var v = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10)));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (input) { changeLine(parseInt(input.getAttribute('data-line-qty'), 10), Math.max(0, parseInt(input.value, 10) || 0), input.closest('.citem')); return; }
    var note = e.target.closest('[data-cart-note]');
    if (note) fetch(routes.cart_update + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* ---------- wishlist (localStorage) ---------- */
  var WKEY = 'yb-wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function setWish(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} syncWish(); }
  function syncWish() {
    var list = getWish();
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; el.setAttribute('data-count', list.length); });
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = b.querySelector('[data-wish-label]');
      if (lbl) lbl.textContent = on ? (strings.wish_remove || 'Saved to wishlist') : (strings.wish_add || 'Add to wishlist');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), list = getWish(), idx = list.indexOf(h);
    if (idx > -1) { list.splice(idx, 1); toast(strings.wish_removed || 'Removed from wishlist'); }
    else { list.unshift(h); toast(strings.wish_added || 'Saved to wishlist'); }
    setWish(list.slice(0, 100));
    var page = b.closest('[data-wishlist-grid]');
    if (page && idx > -1) { var card = b.closest('.pcard'); if (card) card.remove(); if (!getWish().length) renderWishlistPage(); }
  });
  syncWish();

  function fetchCards(handles, container, limit) {
    handles = handles.slice(0, limit || 24);
    return Promise.all(handles.map(function (h) {
      return fetch(root('/products/' + encodeURIComponent(h)) + '?section_id=product-card-fragment')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { if (!html) return ''; var c = parseHTML(html).querySelector('.pcard'); return c ? c.outerHTML : ''; })
        .catch(function () { return ''; });
    })).then(function (cards) {
      container.innerHTML = cards.join('');
      syncWish();
      return cards.filter(Boolean).length;
    });
  }
  function renderWishlistPage() {
    var grid = $('[data-wishlist-grid]'); if (!grid) return;
    var empty = $('[data-wishlist-empty]');
    var list = getWish();
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    fetchCards(list, grid, 60).then(function (n) { if (!n && empty) empty.hidden = false; });
  }
  renderWishlistPage();

  /* ---------- recently viewed ---------- */
  var RKEY = 'yb-recent';
  var current = $('[data-product-handle]');
  var recent = [];
  try { recent = JSON.parse(localStorage.getItem(RKEY)) || []; } catch (e) {}
  $$('[data-recently-viewed]').forEach(function (wrap) {
    var skip = wrap.getAttribute('data-exclude');
    var list = recent.filter(function (h) { return h !== skip; });
    var grid = $('.pgrid', wrap);
    var limit = parseInt(wrap.getAttribute('data-limit') || '6', 10);
    if (!list.length || !grid) return;
    fetchCards(list, grid, limit).then(function (n) { if (n) wrap.hidden = false; });
  });
  if (current) {
    var h = current.getAttribute('data-product-handle');
    recent = recent.filter(function (x) { return x !== h; });
    recent.unshift(h);
    try { localStorage.setItem(RKEY, JSON.stringify(recent.slice(0, 20))); } catch (e) {}
  }

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = parseHTML(html).querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.pcard')) { el.innerHTML = fresh.innerHTML; el.hidden = false; syncWish(); }
      })
      .catch(function () {});
  });

  /* ---------- collection / search facets ---------- */
  function facetsRoot() { return $('[data-facets]'); }
  function renderFacets(url, push) {
    var rootEl = facetsRoot(); if (!rootEl) return;
    var sectionId = rootEl.getAttribute('data-section-id');
    var results = $('[data-facets-results]', rootEl);
    if (results) results.classList.add('loading');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        ['[data-facets-results]', '[data-facets-filters]', '[data-facets-count]', '[data-facets-actives]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel), cur = $(sel, rootEl);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        if (push) history.pushState({ facets: true }, '', url);
        syncWish();
      })
      .finally(function () { var r = $('[data-facets-results]', rootEl); if (r) r.classList.remove('loading'); });
  }
  function formToUrl() {
    var rootEl = facetsRoot();
    var params = new URLSearchParams();
    $$('form[data-facets-form]', rootEl).forEach(function (form) {
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    });
    return window.location.pathname + '?' + params.toString();
  }
  var facetChange = debounce(function () { renderFacets(formToUrl(), true); }, 400);
  document.addEventListener('change', function (e) {
    if (e.target.closest('form[data-facets-form]')) facetChange();
  });
  document.addEventListener('input', function (e) {
    if (e.target.closest('form[data-facets-form]') && e.target.type === 'number') facetChange();
  });
  document.addEventListener('submit', function (e) {
    if (e.target.closest('form[data-facets-form]')) { e.preventDefault(); renderFacets(formToUrl(), true); }
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-facet-link]');
    if (!a || !facetsRoot()) return;
    e.preventDefault();
    renderFacets(a.getAttribute('href'), true);
    if (a.closest('.pager')) facetsRoot().scrollIntoView({ behavior: 'smooth' });
  });
  window.addEventListener('popstate', function (e) { if (e.state && e.state.facets) renderFacets(window.location.href, false); });

  /* ---------- product page ---------- */
  $$('[data-product-form-root]').forEach(function (rootEl) {
    var jsonEl = $('script[data-product-json]', rootEl);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var sectionId = rootEl.getAttribute('data-section-id');
    var idInputs = $$('input[name="id"]', rootEl);

    function selectedOptions() {
      return $$('[data-option-index]', rootEl).map(function (group) {
        var sel = group.querySelector('select');
        if (sel) return sel.value;
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function showMedia(id) {
      var stage = $('.stage', rootEl); if (!stage || !id) return;
      var target = $('.media[data-media-id="' + id + '"]', stage);
      if (!target) return;
      $$('.media', stage).forEach(function (m) { m.classList.toggle('on', m === target); });
      $$('.thumbs button', rootEl).forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-media-id') === String(id)); });
    }
    rootEl.addEventListener('click', function (e) {
      var t = e.target.closest('.thumbs button');
      if (t) showMedia(t.getAttribute('data-media-id'));
    });

    rootEl.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option-index]')) return;
      $$('.opts label', rootEl).forEach(function (l) { var i = l.querySelector('input'); l.classList.toggle('checked', !!(i && i.checked)); });
      var opts = selectedOptions();
      $$('[data-option-index]', rootEl).forEach(function (g, i) { var lbl = g.querySelector('[data-selected-value]'); if (lbl) lbl.textContent = opts[i] || ''; });
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      var buttons = $$('[data-add-button]', rootEl);
      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; var s = b.querySelector('span'); if (s) s.textContent = strings.unavailable || 'Unavailable'; });
        return;
      }
      idInputs.forEach(function (i) { i.value = variant.id; i.dispatchEvent(new Event('change', { bubbles: true })); });
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (rootEl.hasAttribute('data-update-url')) history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id);
      fetch(window.location.pathname + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          $$('[data-swap]', rootEl).forEach(function (el) {
            var fresh = doc.querySelector('[data-swap="' + el.getAttribute('data-swap') + '"]');
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
          var freshBtn = doc.querySelector('[data-add-button]');
          buttons.forEach(function (b) { if (freshBtn) { b.disabled = freshBtn.disabled; b.innerHTML = freshBtn.innerHTML; } });
          $$('.opts label', rootEl).forEach(function (l, idx) {
            var fl = doc.querySelectorAll('.opts label')[idx];
            if (fl) l.classList.toggle('unavailable', fl.classList.contains('unavailable'));
          });
        });
    });

    // tabs
    $$('[data-tabs]', rootEl.parentNode || document).forEach(function (tabs) {
      if (tabs._init) return; tabs._init = true;
      var btns = $$('[role="tab"]', tabs);
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { var on = b === btn; b.classList.toggle('on', on); b.setAttribute('aria-selected', on); var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.classList.toggle('on', on); });
        });
      });
    });
  });

  // tabs outside product root
  $$('[data-tabs]').forEach(function (tabs) {
    if (tabs._init) return; tabs._init = true;
    var btns = $$('[role="tab"]', tabs);
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { var on = b === btn; b.classList.toggle('on', on); b.setAttribute('aria-selected', on); var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.classList.toggle('on', on); });
      });
    });
  });

  /* ---------- customer addresses ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]');
    if (!t) return;
    e.preventDefault();
    var el = document.getElementById(t.getAttribute('data-toggle'));
    if (el) el.hidden = !el.hidden;
  });
  document.addEventListener('click', function (e) {
    var d = e.target.closest('[data-address-delete]');
    if (!d) return;
    e.preventDefault();
    if (!window.confirm(d.getAttribute('data-confirm') || 'Delete this address?')) return;
    var f = document.createElement('form');
    f.method = 'post'; f.action = d.getAttribute('data-address-delete');
    f.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(f); f.submit();
  });
  if (window.Shopify && Shopify.CountryProvinceSelector) {
    $$('[data-address-country]').forEach(function (sel) {
      new Shopify.CountryProvinceSelector(sel.id, sel.getAttribute('data-province-id'), { hideElement: sel.getAttribute('data-province-wrap') });
    });
  }

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-carousel]', e.target).forEach(initCarousel);
    tickCountdowns();
    syncWish();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.slide');
    var car = slide && slide.closest('[data-carousel]');
    if (!car) return;
    var idx = $$('.slide', car).indexOf(slide);
    var dot = $$('.dots button', car)[idx];
    if (dot) dot.click();
  });
})();
